'use client'
import React, { useState } from 'react';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import { IoClose } from 'react-icons/io5';

interface InfoButtonProps {
  content: string;
}

export const InfoButton: React.FC<InfoButtonProps> = ({ content }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleModal = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <button
        onClick={toggleModal}
        className="ml-2 p-1 text-blue-600 hover:text-blue-800 transition-colors"
        type="button"
        aria-label="Prikaži informacije"
      >
        <AiOutlineInfoCircle size={20} />
      </button>

      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[80vh] overflow-y-auto">
            <div className="sticky top-0 bg-white border-b px-6 py-4 flex items-center justify-between">
              <h3 className="text-lg font-semibold text-gray-900">
                Informacije o postavci
              </h3>
              <button
                onClick={toggleModal}
                className="text-gray-500 hover:text-gray-700 transition-colors"
                aria-label="Zatvori"
              >
                <IoClose size={24} />
              </button>
            </div>
            <div className="px-6 py-4">
              <div className="prose prose-sm max-w-none">
                <div 
                  className="whitespace-pre-line text-gray-700 leading-relaxed"
                  dangerouslySetInnerHTML={{ __html: content }}
                >
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};